module.exports = __webpack_public_path__ + "img/5316a45cf639d6ff1456aaf6463895ff.30eac132.png";